import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from '../../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { CopySink } from 'app/model/pipeline/copysink/copysink';
import { FormatWriteSettingsAdapter, formatWriteSettingsAdapts } from './format-write-settings.adapter';
import { DelimitedTextFormatWriteSettings } from 'app/model/pipeline/copysink/format-write-settings/delimited-text-format-write-settings';
import { ValueAdapter } from 'app/model/adapters/value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DelimitedTextFormatWriteSettings),
    asynchronous: true,
    adapts: {
        fileExtension: '*',
        quoteAllText: !__IS_FABRIC_DPE__ ? '*' : undefined,
        ...formatWriteSettingsAdapts
    }
})
export class DelimitedTextFormatWriteSettingsAdapter extends FormatWriteSettingsAdapter<
    DelimitedTextFormatWriteSettings,
    Model.FormatWriteSettings
> {
    protected override async _toResource(model: DelimitedTextFormatWriteSettings): Promise<Model.FormatWriteSettings> {
        const result: Model.DelimitedTextFormatWriteSettings =
            FormatWriteSettingsAdapter.getCommonWriteSettingsProperties(
                Metamodel.modelFor(DelimitedTextFormatWriteSettings).name
            );
        FormatWriteSettingsAdapter.toFormatWriteSettingsResource(model, result);
        if (!__IS_FABRIC_DPE__) {
            result.quoteAllText = ValueAdapter.toResource(model, DelimitedTextFormatWriteSettings.QUOTE_ALL_TEXT);
        }
        result.fileExtension = ValueAdapter.toResource(model, DelimitedTextFormatWriteSettings.FILE_EXTENSION);
        return result;
    }

    protected override async _toModel(
        resource: Model.DelimitedTextFormatWriteSettings,
        copySink: CopySink
    ): Promise<DelimitedTextFormatWriteSettings> {
        const result = FormatWriteSettingsAdapter.createWriteSettingsWithCommonProperties(
            DelimitedTextFormatWriteSettings.MODEL,
            copySink
        ) as DelimitedTextFormatWriteSettings;
        FormatWriteSettingsAdapter.toFormatWriteSettingsModel(resource, result);
        if (!__IS_FABRIC_DPE__) {
            ValueAdapter.toModel(result, DelimitedTextFormatWriteSettings.QUOTE_ALL_TEXT, resource.quoteAllText);
        }
        ValueAdapter.toModel(result, DelimitedTextFormatWriteSettings.FILE_EXTENSION, resource.fileExtension);
        return result;
    }
}
